import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import axiosInstance, { notificationBaseUrl, notificationUpdateURL } from './util.js';

var getBaseUrl = function getBaseUrl(hostUrl, endPrefixUrl) {
  return hostUrl ? "".concat(hostUrl).concat(endPrefixUrl) : "".concat(endPrefixUrl);
};
var getAllNotifications = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(hostUrl, appId) {
    var url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = getBaseUrl(hostUrl, notificationBaseUrl);
          return _context.abrupt("return", axiosInstance.get("".concat(url, "?applicationId=").concat(appId, "&limit=100")).then(function (response) {
            return response.data;
          })["catch"](function (err) {
            throw err;
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getAllNotifications(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var updateNotification = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(Request, hostUrl) {
    var url;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = getBaseUrl(hostUrl, notificationUpdateURL);
          _context2.next = 3;
          return axiosInstance.put(url, Request).then(function (response) {
            return response.data.data;
          })["catch"](function (err) {
            throw err;
          });
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function updateNotification(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

export { getAllNotifications, updateNotification };
